// https://codepen.io/nishiohirokazu/pen/jjNyye
function wrapText(context, text, x, y, width, lineHeight) {
  const startY = y;
  const paragraphs = text.split('\n');
  for (let p = 0; p < paragraphs.length; p++) {
    const words = paragraphs[p].split(' ');
    let line = '';

    for (let n = 0; n < words.length; n++) {
      const testLine = line + words[n] + ' ';
      const metrics = context.measureText(testLine);
      if (metrics.width > width && n > 0) {
        context.fillText(line, x, y);
        line = words[n] + ' ';
        y += lineHeight;
      } else {
        line = testLine;
      }
    }
    context.fillText(line, x, y);
    y += lineHeight;
  }
  return y - startY;
}

const createOverlayFromText = async (
  title,
  text,
  podiumWidth,
  podiumHeight
) => {
  let canvas = null;
  const supportsOffscreen = typeof window.OffscreenCanvas === 'function';
  if (supportsOffscreen) {
    canvas = new OffscreenCanvas(podiumWidth, podiumHeight);
  } else {
    canvas = document.createElement('canvas');
    canvas.width = podiumWidth;
    canvas.height = podiumHeight;
  }
  const ctx = canvas.getContext('2d');
  let x = 240;
  let y = podiumHeight * 0.625;
  const width = 800;
  const padding = 15;
  const lineHeight = 21;
  ctx.fillStyle = '#000';
  ctx.textAlign = 'left';
  ctx.textBaseline = 'top';
  ctx.font = 'bold 16px Verdana';
  ctx.fillText(title, x + padding, y + padding);
  ctx.font = '16px Verdana';
  const textHeight = wrapText(
    ctx,
    text,
    x + padding,
    y + padding + lineHeight + 3,
    width - 2 * padding,
    lineHeight
  );
  ctx.fillStyle = '#ffffffcc';
  ctx.globalCompositeOperation = 'destination-over';
  ctx.beginPath();
  ctx.roundRect(x, y, width, textHeight + lineHeight + 2 * padding - 4, 5);
  ctx.fill();
  if (supportsOffscreen) {
    return canvas.convertToBlob();
  } else {
    return new Promise((resolve) => canvas.toBlob(resolve));
  }
};

export { createOverlayFromText };
